import BreadCrumb from "Common/BreadCrumb";
import React from "react";
import { Container, Row } from "react-bootstrap";
import ContactsUs from "./Contact-Us";

const ContactUs = () => {
  document.title = "Contacts";

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Contacts" pageTitle="More" />
          <Row>
            <ContactsUs />
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ContactUs;
